module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-SemiBold.ebb2f943.woff2";